import type { SneezeStage } from "../content/sneeze";

interface StageRailProps {
  stages: SneezeStage[];
  activeIndex: number;
  stageProgress: number;
  onChoose: (index: number) => void;
}

export function StageRail({ stages, activeIndex, stageProgress, onChoose }: StageRailProps) {
  return (
    <nav className="stage-rail panel" aria-label="Sneeze sequence">
      <div className="panel__label">Journey</div>
      <ol className="stage-list">
        {stages.map((stage, index) => {
          const active = index === activeIndex;
          const complete = index < activeIndex;
          return (
            <li key={stage.id}>
              <button
                type="button"
                className={`stage-button${active ? " is-active" : ""}${complete ? " is-complete" : ""}`}
                onClick={() => onChoose(index)}
                aria-current={active ? "step" : undefined}
              >
                <span className="stage-button__number">{String(stage.order).padStart(2, "0")}</span>
                <span className="stage-button__copy">
                  <strong>{stage.navLabel}</strong>
                  <small>{stage.subLabel}</small>
                </span>
                <span className="stage-button__state" aria-hidden="true">
                  {complete ? "✓" : active ? `${Math.round(stageProgress * 100)}%` : ""}
                </span>
                {active && (
                  <span
                    className="stage-button__progress"
                    style={{ transform: `scaleX(${stageProgress})` }}
                    aria-hidden="true"
                  />
                )}
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
